import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import TrackVisibility from 'react-on-screen';
import { ArrowRight } from '@phosphor-icons/react';
import { useLocation } from 'react-router-dom';
import NewsItemComponent from '../containers/NewsItemContainer';
// import Banner from '../../../common/Banner/Banner';
// import debouncer from '../../../helpers/redux-breakpoint-ssr/debouncer';
import Button from '../../../common/button/Button';
import Spinner from '../../../common/Spinner/Spinner';
import TruncatedContent from '../../../utils/TruncatedContent';

// It may be the news blocks pattern in future, but it still need some feats to be so
// (like categorySlugs and check the filtered category)

const NewsBlock = ({
    isLoading,
    isSinglePage,
    getNewsDataIfNeeded,
    getFilteredNewsIfNeeded,
    checkForNewNews,
    newsPageData,
    newsFiltered,
    newsId,
    breakpoint,
    // bannerConfig,
    numNews,
    numNewsMobile,
    showFeatured,
    title,
    buttonText,
    skipFeatured,
    category,
    currentCategorySlug,
}) => {
    const serverBreakpoints = breakpoint.serverBreakPoints;
    const isSmall = serverBreakpoints && (serverBreakpoints.isSmall || serverBreakpoints.isExtraSmall);
    let initialNumNews = isSmall && numNewsMobile ? numNewsMobile : numNews;

    // add 1 news if the featured news is skipped
    if (initialNumNews && skipFeatured) initialNumNews += 1;

    const state = {
        numNews: 9,
        initialNews: initialNumNews || 9,
        infiniteScroll: !initialNumNews || initialNumNews > 12,
        category: category || currentCategorySlug,
    };

    useEffect(() => {
        const loadInitialData = () => {
            if (!state.category || state.category === 'tudo') {
                if (newsPageData.length < state.initialNews) {
                    getNewsDataIfNeeded(state.initialNews, newsPageData.length);
                }

                checkForNewNews('tudo');
            } else if (state.category !== currentCategorySlug) {
                // the category changed, get fresh news
                getFilteredNewsIfNeeded(state.initialNews, 0, state.category);
            } else if (newsFiltered.length < state.initialNews) {
                // get more news
                getFilteredNewsIfNeeded(state.initialNews, newsFiltered.length, state.category);

                checkForNewNews(state.category);
            }
        };

        loadInitialData();
    }, [state.category,
        currentCategorySlug,
        state.initialNews,
        newsPageData,
        newsFiltered,
        getNewsDataIfNeeded,
        getFilteredNewsIfNeeded,
        checkForNewNews]);

    // const { category: stateCategory, infiniteScroll } = state;

    // const scrollRequest = useCallback(() => {
    //     const body = document.body;
    //     const html = document.documentElement;
    //     const height = Math.max(
    //         body.scrollHeight,
    //         body.offsetHeight,
    //         html.clientHeight,
    //         html.scrollHeight,
    //         html.offsetHeight,
    //     );
    //     const diff = height - window.innerHeight - window.scrollY;

    //     if (diff <= 1500 && !isLoading) {
    //         // only load more news if not already loading
    //         if (!stateCategory || stateCategory === 'tudo') {
    //             getNewsDataIfNeeded(16, newsPageData.size);
    //         } else {
    //             getFilteredNewsIfNeeded(16, newsFiltered.size, stateCategory);
    //         }
    //     }
    // }, [stateCategory, isLoading, newsPageData.size, newsFiltered.size, getNewsDataIfNeeded, getFilteredNewsIfNeeded]);

    // const debouncedScroll = useCallback(() => debouncer(scrollRequest, 100), [scrollRequest]);

    // useEffect(() => {
    //     if (infiniteScroll) {
    //         window.addEventListener('scroll', debouncedScroll);

    //         return () => window.removeEventListener('scroll', debouncedScroll);
    //     }
    // }, [infiniteScroll, debouncedScroll]);


    const mapNewsPage = (newsData) => {
        if (!newsData) return false;

        const limitedNewsData = state.numNews ? newsData.slice(0, state.numNews) : newsData.slice(0, 4);
        // eslint-disable-next-line no-unused-vars
        let indexNews = 0;

        return limitedNewsData.map((data, index) => {
            // if (index === limitedNewsData.length - 1 && indexNews % 2 === 0) return null;

            if (isSinglePage && newsId === data.id) return null;

            if (skipFeatured && data.featuredImage !== null) return null;

            const isFeatured = showFeatured && data.featuredImage !== null && index === 0;

            if (!isFeatured) indexNews += 1;

            return (
                // eslint-disable-next-line react/no-array-index-key
                <React.Fragment key={index}>
                    <TrackVisibility className="box">
                        <NewsItemComponent
                            isFeatured={isFeatured}
                            showContent
                            data={data}
                        />
                    </TrackVisibility>
                    {/* {bannerConfig && indexNews % 8 === 0 && indexNews !== 0 && (
                        <div className="bannersNews">
                            <Banner config={bannerConfig} />
                        </div>
                    )} */}
                </React.Fragment>
            );
        });
    };

    const newsData = (!state.category || state.category === 'tudo') ? newsPageData : newsFiltered;

    const location = useLocation();

    return (
        <section className={`tw-container tw-mx-auto tw-y-8 tw-py-4 ${location.pathname === '/' ? 'tw-px-5' : 'tw-px-0'} category-news-section`}>
            {title && (
                <header className="tw-mb-3 tw-flex tw-items-center tw-justify-between tw-border-t tw-border-b tw-border-gray-700 tw-pt-4 tw-pb-4 tw-p-0">
                    <h2 className="tw-mb-0">
                        <TruncatedContent content={title} maxLength={60} />
                    </h2>
                    {buttonText && (
                        <div className="">
                            <Button
                                className="tw-font-medium tw-py-2 tw-rounded-lg tw-flex tw-items-center tw-gap-2"
                                to="noticias?scroll_to_last=true"
                                title="Ir para a página noticias"
                            >
                                {buttonText}
                                <span>
                                    {' '}
                                    <ArrowRight size={20} weight="bold" />
                                </span>
                            </Button>
                        </div>
                    )}
                </header>
            )}
            <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-grid-cols-4 tw-gap-10">
                {mapNewsPage(newsData)}
                {isLoading && <Spinner />}
            </div>
        </section>
    );
};

NewsBlock.propTypes = exact({
    isLoading: PropTypes.bool.isRequired,
    isSinglePage: PropTypes.bool,
    getNewsDataIfNeeded: PropTypes.func.isRequired,
    getFilteredNewsIfNeeded: PropTypes.func.isRequired,
    checkForNewNews: PropTypes.func.isRequired,
    newsPageData: PropTypes.array,
    newsFiltered: PropTypes.array,
    newsId: PropTypes.number,
    breakpoint: PropTypes.object.isRequired,
    // bannerConfig: PropTypes.object,
    numNews: PropTypes.number,
    numNewsMobile: PropTypes.number,
    showFeatured: PropTypes.bool,
    title: PropTypes.string,
    buttonText: PropTypes.string,
    skipFeatured: PropTypes.bool,
    category: PropTypes.string,
    currentCategorySlug: PropTypes.string,
});

export default NewsBlock;
